import CharmSuggestionsStore from '../schema/CharmSuggestionsStore';
import store from '../store';
import { action } from 'satcheljs/lib/legacy';

export interface ResetCharmSuggestionsHighlightedIndex {
    store: CharmSuggestionsStore;
}

/**
 * Resets the value of the charm suggestions highlighted index
 */
export default action('resetCharmSuggestionsHighlightedIndex')(
    function resetCharmSuggestionsHighlightedIndex(
        state: ResetCharmSuggestionsHighlightedIndex = { store: store }
    ) {
        {
            state.store.highlightedIndex = 0;
        }
    }
);
